// v83 — open the live-streamer drawer from anywhere (LiveDrawerHost in AppShell listens).
export const HOST = { subs: new Set() };
export function openLive(id) { HOST.subs.forEach((fn) => fn(id)); }

// Plain click opens the drawer; Ctrl/Cmd/Shift/middle click still opens the full page.
export const liveClick = (id) => (e) => {
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
  e.preventDefault();
  openLive(id);
};
